import { createSlice } from "@reduxjs/toolkit";

import {
  getInvoiceThunk,
  createInvoiceThunk,
  updateInvoiceThunk,
  deleteInvoiceThunk,
  updateSalesRecapThunk,
} from "state/action/invoice";

// Initial state
const initialState = {
  // Get Invoice inisial state
  getInvoice: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Invoice inisial state
  createInvoice: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Invoice inisial state
  updateInvoice: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  completedSalesRecap: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  // Delete Invoice inisial state
  deleteInvoice: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  sales_recap: {
    sale_date: "",
    description: "",
    rate_percent: "",
    gross_amount: "",
    net_amount: "",
    total_amount: "",
    status: "pending",
    notes: "",
    revenue_share_amount: "",
  },
  // Invoice object value
  invoice_object_value: "",
  selectedInvoice: null,
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    setSalesRecapInputBody: (state, action) => {
      const { payload } = action;

      // Calculate total_amount based on revenue share scheme
      let updatedPayload = payload;

      if (state.selectedInvoice && state.selectedInvoice.revenueShareDetails) {
        const { revenueShareDetails, pks_id } = state.selectedInvoice;

        const { revenue_type } = revenueShareDetails;

        const schemeType = revenueShareDetails.details?.scheme_type;

        if (revenue_type === "Revenue Share") {
          // Hitung total_amount berdasarkan schema dan tahun pada rules
          const startDate = new Date(pks_id.term.start_date);
          const currentDate = new Date();

          // Hitung tahun kontrak saat ini (tahun 1 adalah tahun start_date)
          const yearDiff = currentDate.getFullYear() - startDate.getFullYear();
          const monthDiff = currentDate.getMonth() - startDate.getMonth();
          const dayDiff = currentDate.getDate() - startDate.getDate();

          // Menentukan tahun kontrak dengan mempertimbangkan bulan dan hari
          let contractYear = yearDiff;
          if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            contractYear--;
          }

          // Pastikan tahun kontrak dalam batas yang valid (minimal tahun 1)
          contractYear = Math.max(0, contractYear);

          // Dapatkan rule yang sesuai berdasarkan tahun kontrak
          let rule = null;
          if (revenueShareDetails.details?.yearly_rates) {
            const rules = revenueShareDetails.details.yearly_rates;

            // Gunakan rule yang sesuai dengan tahun kontrak (index 0 untuk tahun 1)
            rule = rules[Math.min(contractYear, rules.length - 1)];
          }

          if (rule) {
            // Ambil nilai gross_amount dan net_amount dari payload
            const grossAmount = parseFloat(payload.gross_amount) || 0;
            const netAmount = parseFloat(payload.net_amount) || 0;

            // Ambil rate_percent dan period_amount dari rule
            const ratePercent = parseFloat(rule.rate_percent) || 0;
            // const periodAmount = parseFloat(rule.period_amount) || 0;
            const maxRevShare = parseFloat(rule.max_revenue_share_amount) || 0;

            // Hitung revenue share amount berdasarkan net_amount dan rate_percent
            const revenueShareAmount = netAmount * (ratePercent / 100);

            // Untuk Revenue Share With MGP, jika revenueShareAmount melebihi maxRevShare
            // maka yang diambil adalah maxRevShare, jika kurang dari maxRevShare
            // maka ambil revenueShareAmount
            const totalAmount =
              revenueShareAmount > maxRevShare
                ? maxRevShare
                : revenueShareAmount;

            // Update payload dengan nilai yang sudah dihitung
            updatedPayload = {
              ...payload,
              rate_percent: ratePercent,
              revenue_share_amount: revenueShareAmount,
              // mgp_amount: periodAmount,
              total_amount: totalAmount,
              status: "calculated",
            };
          }
        } else if (
          revenue_type === "Revenue Share With MGP" &&
          schemeType === "PERIOD"
        ) {
          // Hitung total_amount berdasarkan schema dan tahun pada rules
          const startDate = new Date(pks_id.term.start_date);
          const currentDate = new Date();

          // Hitung tahun kontrak saat ini (tahun 1 adalah tahun start_date)
          const yearDiff = currentDate.getFullYear() - startDate.getFullYear();
          const monthDiff = currentDate.getMonth() - startDate.getMonth();
          const dayDiff = currentDate.getDate() - startDate.getDate();

          // Menentukan tahun kontrak dengan mempertimbangkan bulan dan hari
          let contractYear = yearDiff;
          if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            contractYear--;
          }

          // Pastikan tahun kontrak dalam batas yang valid (minimal tahun 1)
          contractYear = Math.max(0, contractYear);

          // Dapatkan rule yang sesuai berdasarkan tahun kontrak
          let rule = null;
          if (revenueShareDetails.details?.scheme?.rules) {
            const rules = revenueShareDetails.details.scheme.rules;

            // Gunakan rule yang sesuai dengan tahun kontrak (index 0 untuk tahun 1)
            rule = rules[Math.min(contractYear, rules.length - 1)];
          }

          if (rule) {
            // Ambil nilai gross_amount dan net_amount dari payload
            const grossAmount = parseFloat(payload.gross_amount) || 0;
            const netAmount = parseFloat(payload.net_amount) || 0;

            // Ambil rate_percent dan period_amount dari rule
            const ratePercent = parseFloat(rule.rate_percent) || 0;
            const periodAmount = parseFloat(rule.period_amount) || 0;

            // Hitung revenue share amount berdasarkan net_amount dan rate_percent
            const revenueShareAmount = netAmount * (ratePercent / 100);

            // Untuk Revenue Share With MGP, bandingkan dengan minimum guarantee
            // Pilih nilai yang lebih besar antara revenue share amount dan MGP
            const totalAmount = Math.max(revenueShareAmount, periodAmount);

            // Update payload dengan nilai yang sudah dihitung
            updatedPayload = {
              ...payload,
              rate_percent: ratePercent,
              revenue_share_amount: revenueShareAmount,
              // mgp_amount: periodAmount,
              total_amount: totalAmount,
              status: "calculated",
            };
          }
        }
      }

      return {
        ...state,
        sales_recap: updatedPayload,
      };
    },
    setGetInvoiceObjectValue: (state, action) => {
      return {
        ...state,
        invoice_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetInvoiceObjectValue: (state, _) => {
      return {
        ...state,
        invoice_object_value: "",
      };
    },
    setSelectedInvoice: (state, action) => {
      return {
        ...state,
        selectedInvoice: action.payload,
      };
    },
    setClearGetInvoice: (state, _) => {
      return {
        ...state,
        getInvoice: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateInvoice: (state, _) => {
      return {
        ...state,
        createInvoice: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateInvoice: (state, _) => {
      return {
        ...state,
        updateInvoice: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteInvoice: (state, _) => {
      return {
        ...state,
        deleteInvoice: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllInvoiceState: (state, _) => {
      return {
        ...state,
        // Get Invoice inisial state
        getInvoice: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Invoice inisial state
        createInvoice: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Invoice inisial state
        updateInvoice: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Invoice inisial state
        deleteInvoice: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Invoice object value
        Invoice_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Invoice reducer
      .addCase(getInvoiceThunk.pending, (state, _) => {
        return {
          ...state,
          getInvoice: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getInvoiceThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getInvoice: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getInvoiceThunk.rejected, (state, action) => {
        return {
          ...state,
          getInvoice: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Invoice reducer
      .addCase(createInvoiceThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createInvoiceThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createInvoiceThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Invoice reducer
      .addCase(updateInvoiceThunk.pending, (state, _) => {
        return {
          ...state,
          updateInvoice: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateInvoiceThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateInvoice: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateInvoiceThunk.rejected, (state, action) => {
        return {
          ...state,
          updateInvoice: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Invoice reducer
      .addCase(updateSalesRecapThunk.pending, (state, _) => {
        return {
          ...state,
          completedSalesRecap: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateSalesRecapThunk.fulfilled, (state, action) => {
        return {
          ...state,
          completedSalesRecap: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateSalesRecapThunk.rejected, (state, action) => {
        return {
          ...state,
          completedSalesRecap: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const invoiceAction = {
  ...invoiceSlice.actions,
  getInvoiceThunk,
  createInvoiceThunk,
  updateInvoiceThunk,
  deleteInvoiceThunk,
  updateSalesRecapThunk,
};

export function selectInvoiceObjectValue(state) {
  return state?.invoice?.invoice_object_value;
}

export function selectInvoice(state) {
  return state?.invoice;
}

export default invoiceSlice.reducer;
